var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8111 6.43503V11.565C15.8111 12.405 15.3611 13.185 14.6336 13.6125L10.1786 16.185C9.45109 16.605 8.55109 16.605 7.81609 16.185L3.36109 13.6125C2.63359 13.1925 2.18359 12.4125 2.18359 11.565V6.43503C2.18359 5.59503 2.63359 4.81499 3.36109 4.38749L7.81609 1.815C8.54359 1.395 9.44359 1.395 10.1786 1.815L14.6336 4.38749C15.3611 4.81499 15.8111 5.58753 15.8111 6.43503Z",
    stroke: "#525252",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00141 8.24986C9.96652 8.24986 10.7489 7.46747 10.7489 6.50235C10.7489 5.53723 9.96652 4.75488 9.00141 4.75488C8.03629 4.75488 7.25391 5.53723 7.25391 6.50235C7.25391 7.46747 8.03629 8.24986 9.00141 8.24986Z",
    stroke: "#525252",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.4948C12 11.1448 10.6575 10.0498 9 10.0498C7.3425 10.0498 6 11.1448 6 12.4948",
    stroke: "#525252",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMeeting);
export default __webpack_public_path__ + "static/media/user-meeting.b0ba5679ad8ab37d9e3b73cee7e77c3f.svg";
export { ForwardRef as ReactComponent };